import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseData } from 'src/app/Model/Base/Response';
import { RequestModel } from 'src/app/Model/Request.model';
import { SendMessageOnlyModel } from 'src/app/Model/SendMessageOnlye.model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequestService } from 'src/app/Services/request/request.service';
import { RequesStatusService } from 'src/app/Services/RequestStatus/RequesStatus.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-status-update-message',
  templateUrl: './status-update-message.component.html',
  styleUrls: ['./status-update-message.component.css']
})
export class StatusUpdateMessageComponent implements OnInit {
  idRequest;
  request: RequestModel;
  isValid:boolean=false;
  public isMobile: boolean = false;
  form = new FormGroup({
    message: new FormControl(null, [Validators.required, CustomValidators.HtmlValidator()]),
  });
  get message() { return this.form.get('message'); }
  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly RequestStatus: RequesStatusService,
    private readonly translate: TranslateService,
    private readonly requestService: RequestService,
    breakpointObserver: BreakpointObserver,
    private readonly activatedRoute: ActivatedRoute,
    private readonly lsService : SessionStorageService
  ) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.id != null) {
        this.idRequest = params.id
        this.lsService.setLSItem("IdRequest", params.id)
      }

    });

  }
async isValidDate(){
  let r=false;
  if(this.request.AllowUpdateStatusFrom!=null)
  {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
   let dif=date.getTime()- new Date(this.request.AllowUpdateStatusFrom).getTime();
    let TotalDays = Math.ceil(dif / (1000 * 3600 * 24));
    r=TotalDays<=30; 
  }
  this.isValid= r;

}
  async ngOnInit() {
    await this.loadRequest()
  }
  async loadRequest() {
    await this.spinner.show()
    this.idRequest = this.lsService.getLSItem("IdRequest")
    let rq = await this.requestService.getRequestById(this.idRequest);
    if (rq != null) {
      this.request = rq;
      this.lsService.setLSItem("RequestCode", rq.RequestCode)
      this.isValidDate()
      await this.spinner.hide()
    }
    else {
      await this.spinner.hide()
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('ExtraWarranty.Message.Error'),
        icon: 'error'
      }
      )

    }
  }
  async sendMessage() {
    this.spinner.show();
    let req = new SendMessageOnlyModel();
    req.Message = this.message.value;
    req.IdRequest=this.request.Id;
    let res: ResponseData;
    await this.RequestStatus.SendMessageStatus(req).then(resp => {
      res = resp;
    });
    await this.spinner.hide();
    if (res.head.status.toLowerCase() == 'true') {
      await this.loadRequest()
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      })
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: res.head.error.description,
        icon: 'error'
      }
      )
    }
  }
}
